// extracted by mini-css-extract-plugin
module.exports = {"additionalSkills":"SkillDropdowns_additionalSkills__3gIHI"};